module.exports = __webpack_public_path__ + "static/media/hitoyo.dbbe9003.png";